import type { TypeSTTConfigForm } from '@intone/shared';

import {
  ModelField,
  LanguageField,
  MinConfidenceThresholdField,
  DetectLanguageField,
  InterimResultsField,
  PunctuateField,
  SpokenPunctuationField,
  EnableWordTimeOffsetsField,
  EnableWordConfidenceField,
  EnableVoiceActivityEventsField,
  ProfanityFilterField,
} from './Fields';

export type Props = {
  currentConfig: TypeSTTConfigForm;
  updateConfig: (field: keyof TypeSTTConfigForm, value: any) => void;
};

export function GoogleFields({ currentConfig, updateConfig }: Props) {
  const modelList = [
    { label: 'Chirp_3', value: 'chirp_3' },
    { label: 'Chirp_2', value: 'chirp_2' },
    { label: 'Telephony', value: 'telephony' },
  ];
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <ModelField
          value={currentConfig.model}
          onUpdate={(value) => updateConfig('model', value)}
          modelList={modelList}
        />
        <LanguageField value={currentConfig.language} onUpdate={(value) => updateConfig('language', value)} />
        <MinConfidenceThresholdField
          value={currentConfig.min_confidence_threshold}
          onUpdate={(value) => updateConfig('min_confidence_threshold', value)}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <DetectLanguageField
          value={currentConfig.detect_language}
          onUpdate={(value) => updateConfig('detect_language', value)}
        />
        <InterimResultsField
          value={currentConfig.interim_results}
          onUpdate={(value) => updateConfig('interim_results', value)}
        />
        <PunctuateField value={currentConfig.punctuate} onUpdate={(value) => updateConfig('punctuate', value)} />
        <SpokenPunctuationField
          value={currentConfig.spoken_punctuation}
          onUpdate={(value) => updateConfig('spoken_punctuation', value)}
        />
        <EnableWordTimeOffsetsField
          value={currentConfig.enable_word_time_offsets}
          onUpdate={(value) => updateConfig('enable_word_time_offsets', value)}
        />
        <EnableWordConfidenceField
          value={currentConfig.enable_word_confidence}
          onUpdate={(value) => updateConfig('enable_word_confidence', value)}
        />
        <EnableVoiceActivityEventsField
          value={currentConfig.enable_voice_activity_events}
          onUpdate={(value) => updateConfig('enable_voice_activity_events', value)}
        />
        <ProfanityFilterField
          value={currentConfig.profanity_filter}
          onUpdate={(value) => updateConfig('profanity_filter', value)}
        />
      </div>
    </div>
  );
}